import { useToastContext } from "components/alert/ToastContext";
import AcaoAuditoria from "model/auditoria5s/auditoria/AcaoAuditoria";
import ComentarioAuditoria from "model/auditoria5s/auditoria/ComentarioAuditoria";
import ItemClasseAuditoria from "model/auditoria5s/auditoria/ItemClasseAuditoria";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import AuditoriaService from "service/auditoria5s/AuditoriaService";
import ExecucaoAuditoriaService from "service/auditoria5s/ExecucaoAuditoriaService";
import ItemAuditoriaService from "service/auditoria5s/ItemAuditoriaService";
import "./AuditoriaExecutarItemPage.scss";
import { Label } from "components/input/Label";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { RadioButton } from "primereact/radiobutton";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import MultiSeletor from "components/multiSeletor/MultiSeletor";
import ModalComentarioAuditoria from "components/modal/auditoria/ModalComentarioAuditoria";
import ModalComentarioAuditoriaCadastro from "./modal/ModalComentarioAuditoriaCadastro";
import ModalAcaoAuditoriaCadastro from "./modal/ModalAcaoAuditoriaCadastro";

const auditoriaService = new AuditoriaService();
const execucaoAuditoriaService = new ExecucaoAuditoriaService();
const itemAuditoriaService = new ItemAuditoriaService();


function AuditoriaExecutarItemPage() {

    const navigate = useNavigate();
    const [title, setTitle] = useState<string>('Item');
    const { msgAlerta } = useToastContext();
    const { startLoading, stopLoading } = useLoadingContext();
    const [visibleOpcaoNaoAplicavel, setVisibleOpcaoNaoAplicavel] = useState(false);
    const [modalComentario, setModalComentario] = useState<{ visible: boolean, comentario: ComentarioAuditoria | null, item: ItemClasseAuditoria }>({ visible: false, comentario: null, item: new ItemClasseAuditoria() });
    const [modalAcao, setModalAcao] = useState<{ visible: boolean, acao: AcaoAuditoria | null, item: ItemClasseAuditoria }>({ visible: false, acao: null, item: new ItemClasseAuditoria() });


    const [item, setItem] = useState<ItemClasseAuditoria>(new ItemClasseAuditoria());

    useEffect(() => {

        setTitle("Item");

        let id = window.location.pathname.substring(`/minhasAuditorias/executar/item/`.length)
        startLoading();
        itemAuditoriaService.consultar(parseInt(id)).then(itemParam => {
            setItem(itemParam);
            stopLoading();
        }).catch(e => {
            console.error(e);
            stopLoading();
        });

        execucaoAuditoriaService.temOpcaoNaoAplicavel().then((json) => {
            setVisibleOpcaoNaoAplicavel(json);
        }).catch(error => {
            console.error(error);
        });

    }, []);

    function adicionarAcao() {
        setModalAcao({ visible: true, acao: null, item: item });
    }

    function editarAcao(acaoParam: AcaoAuditoria) {
        setModalAcao({ visible: true, acao: acaoParam, item: item });
    }

    function apagarAcao(acaoParam: AcaoAuditoria) {
        confirmDialog({
            message: 'Deseja realmente apagar a ação?',
            header: 'Apagar ação',
            icon: 'pi pi-info-circle',
            accept: () => {
                execucaoAuditoriaService.apagarAcao(acaoParam.id).then(() => {
                    item.acoesAuditoria = item.acoesAuditoria.filter(c => c.id !== acaoParam.id);
                    setItem({ ...item });
                }).catch(e => {
                    console.log(e);
                });
            },
            reject: () => { }
        })
    }

    function adicionarComentario() {
        setModalComentario({ visible: true, comentario: null, item: item });
    }

    function editarComentario(comentarioParam: ComentarioAuditoria) {
        setModalComentario({ visible: true, comentario: comentarioParam, item: item });
    }
    function apagarComentario(comentarioParam: ComentarioAuditoria) {
        confirmDialog({
            message: 'Deseja realmente apagar o comentário?',
            header: 'Apagar comentário',
            icon: 'pi pi-info-circle',
            accept: () => {
                execucaoAuditoriaService.apagarComentario(comentarioParam.id).then(() => {
                    item.comentariosAuditoria = item.comentariosAuditoria.filter(c => c.id !== comentarioParam.id);
                    setItem({ ...item });
                }).catch(e => {
                    console.log(e);
                });
            },
            reject: () => { }
        })
    }

    function gravarItem() {
        startLoading();
        itemAuditoriaService.salvarItem(item).then(() => {
            stopLoading();
            navigate(-1);
        }).catch(e => {
            stopLoading();
            if (e && e.data && e.data.message) {
                msgAlerta('', e.data.message);
            } else {
                msgAlerta('', 'Ocorreu um erro ao tentar gravar o item');
            }
        });

    }

    function podeFinalizar(): boolean {

        if (!item.resultado) {
            msgAlerta("", "Insira um resultado para finalizar o item");
            return false;
        }
        if (item.resultado !== "CONFORME" && item.resultado !== "NAO_APLICAVEL" && (!item.comentariosAuditoria || item.comentariosAuditoria.length === 0)) {
            msgAlerta("", "Insira um comentário para finalizar o item")
            return false;
        }
        if (item.requisitoAuditoria.permiteResposta && item.requisitoAuditoria.respostaObrigatoria && item.resultado !== "NAO_APLICAVEL") {
            if (item.tipoResposta == "TEXTO" && !item.resposta) {
                msgAlerta("", "Resposta obrigatório, insira a resposta para prosseguir")
                return false;
            }
            if (item.tipoResposta == "MULTI_ESCOLHA" && item.opcoesResposta && item.opcoesResposta.filter(opcao => opcao.escolhida).length == 0) {
                msgAlerta("", "Resposta obrigatório, selecione uma opção para prosseguir")
                return false;
            }
        }


        return true;
    }

    function finalizarItem() {
        if (!podeFinalizar()) {
            return;
        }
        startLoading()

        itemAuditoriaService.salvarItem(item).then(() => {
            itemAuditoriaService.finalizarItemAuditoria(item).then(() => {
                stopLoading();
                navigate(-1);
            }).catch(error => {
                stopLoading();
                console.error('Erro ao enviar a requisição:', error);
            });
        }).catch(e => {
            stopLoading();
            if (e && e.data && e.data.message) {
                msgAlerta('', e.data.message);
            } else {
                msgAlerta('', 'Ocorreu um erro ao tentar finalizar esse item');
            }
        });
    }

    const optionsResultado = visibleOpcaoNaoAplicavel ? [
        { label: "Conforme", value: "CONFORME", color: "#22c75f", icon: "check" },
        { label: "Parcial", value: "PARCIAL", color: "#AAA", icon: "circle-minus" },
        { label: "Não conforme", value: "NAO_CONFORME", color: "#CB1301", icon: "close" },
        { label: "Não aplivável", value: "NAO_APLICAVEL", color: "#AAA", textIcon: "NA" }
    ] : [
        { label: "Conforme", value: "CONFORME", color: "#22c75f", icon: "check" },
        { label: "Parcial", value: "PARCIAL", color: "#AAA", icon: "circle-minus" },
        { label: "Não conforme", value: "NAO_CONFORME", color: "#CB1301", icon: "close" },
    ]

    return (

        <div>
            <ConfirmDialog />
            {modalComentario.visible ? <ModalComentarioAuditoriaCadastro
                comentario={modalComentario.comentario}
                item={modalComentario.item}
                visible={modalComentario.visible}
                onHide={() => setModalComentario({ visible: false, comentario: null, item: new ItemClasseAuditoria() })}
                onSave={(comentario) => {
                    if (item.comentariosAuditoria.findIndex(coment => coment.id == comentario.id) === -1) {
                        item.comentariosAuditoria.push(comentario);
                    } else {
                        item.comentariosAuditoria = item.comentariosAuditoria.map(coment => coment.id === comentario.id ? comentario : coment);
                    }
                    setItem({ ...item });
                }}
            /> : null}

            {modalAcao.visible ? <ModalAcaoAuditoriaCadastro
                acao={modalAcao.acao}
                item={modalAcao.item}
                visible={modalAcao.visible}
                onHide={() => setModalAcao({ visible: false, acao: null, item: new ItemClasseAuditoria() })}
                onSave={(acao) => {
                    if (item.acoesAuditoria.findIndex(acaoL => acaoL.id == acao.id) === -1) {
                        item.acoesAuditoria.push(acao);
                    } else {
                        item.acoesAuditoria = item.acoesAuditoria.map(acao => acao.id === acao.id ? acao : acao);
                    }
                    setItem({ ...item });
                }}
            /> : null}
            <div className="card-item">
                <span style={{ fontWeight: 'bold', fontSize: 18, paddingBottom: 4 }}>Inspeção: {item.nome}</span>
                <span><span style={{ fontWeight: "bold" }}>Status:</span> Aguardando ações</span>
                <span><span style={{ fontWeight: "bold" }}>Classificação:</span> {item.requisitoAuditoria.classificacaoRequisito?.nome}</span>
                <span><span style={{ fontWeight: "bold" }}>Total de ações:</span> {item.acoesAuditoria.length}</span>
                <span><span style={{ fontWeight: "bold" }}>Ações pendentes:</span> {execucaoAuditoriaService.getTotalAcoesPendentes(item)}</span>
            </div>

            <div className="card-item">
                <Label style={{ fontWeight: 'bold', paddingBottom: 4 }} >Como verificar:</Label>
                <span>{item.descricao}</span>
            </div>

            {item.requisitoAuditoria.permiteResposta && item.tipoResposta == "TEXTO" ? <div className="card-item">

                <Label style={{ fontWeight: 'bold', paddingBottom: 4 }}>Resposta</Label>
                <InputTextarea style={{ backgroundColor: '#ffffff', borderRadius: 4, color: "#000" }}
                    value={item.resposta}
                    onChange={e => {
                        item.resposta = e.target.value
                        setItem({ ...item });
                    }}
                    maxLength={255}
                    placeholder="Insira a resposta"
                />
            </div> : null}

            {item.requisitoAuditoria.permiteResposta && item.tipoResposta == "MULTI_ESCOLHA" ?
                <div className="card-item" >

                    <Label style={{ fontWeight: 'bold', paddingBottom: 4 }}>Resposta</Label>
                    {item.opcoesResposta && item.opcoesResposta.map((opcao, index) => <div style={{ display: "flex", alignItems: "center" }} key={index}>
                        <RadioButton checked={opcao.escolhida} onClick={() => {
                            item.opcoesResposta.forEach(opcaoForEach => {
                                opcaoForEach.escolhida = false;
                            });
                            opcao.escolhida = true;
                            setItem({ ...item });
                        }} value={opcao.id} />
                        <label>{opcao.resposta}</label>
                    </div>)}


                </div>
                : null}

            <div className="card-item" >
                <Label style={{ fontWeight: 'bold', paddingBottom: 4 }}>Resultado</Label>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <MultiSeletor
                        options={optionsResultado}
                        value={item.resultado}
                        onChange={(value) => {
                            item.resultado = value;
                            setItem({ ...item });
                        }}
                        width={"420px"}
                        itemWidth={visibleOpcaoNaoAplicavel ? 105 : 140}
                    />
                </div>

            </div>

            <DataTable value={item.comentariosAuditoria} emptyMessage="nenhum comentário registrado" header={
                <div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
                    <div></div>
                    <span style={{ textAlign: 'center', alignSelf: "center", position: 'relative' }}>Comentários</span>
                    <div>
                        <Button icon="pi pi-plus" onClick={() => adicionarComentario()} />
                    </div>
                </div>
            } style={{ width: '100%' }}>
                <Column field="comentario" header="Comentário" />
                <Column style={{ width: 150 }} body={(rowData: ComentarioAuditoria) => <>
                    <Button style={{ marginRight: 8 }} icon="pi pi-pencil" onClick={() => { editarComentario(rowData) }} />
                    <Button icon="pi pi-trash" onClick={() => { apagarComentario(rowData) }} />
                </>} />
            </DataTable>

            <DataTable value={item.acoesAuditoria} emptyMessage="nenhuma ação registrada" header={
                <div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
                    <div></div>
                    <span style={{ textAlign: 'center', alignSelf: "center", position: 'relative' }}>Ações</span>
                    <div>
                        <Button icon="pi pi-plus" onClick={() => adicionarAcao()} />
                    </div>
                </div>
            } style={{ width: '100%', marginTop: 8 }}>
                <Column field="nome" header="Ação" />
                <Column field="status" body={(rowData) => auditoriaService.getStatusAcaoAuditoria(rowData.status)} header="Status" style={{ width: 100 }} bodyClassName={(rowData) => rowData.status === "CRIADO" || rowData.status === "EM_ANDAMENTO" ? "text-yellow" : "text-green"} />
                <Column style={{ width: 150 }} body={(rowData: AcaoAuditoria) => <>
                    <Button style={{ marginRight: 8 }} icon="pi pi-pencil" onClick={() => { editarAcao(rowData) }} />
                    <Button icon="pi pi-trash" onClick={() => { apagarAcao(rowData) }} />
                </>} />
            </DataTable>

            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', marginTop: 8 }}>
                <Button type="button" label="Voltar" className="ui-button-info" onClick={() => navigate(-1)}></Button>
                <Button style={{ marginLeft: 8,  backgroundColor: "#240E92", color: "#FFF" }} onClick={() => {
                    gravarItem();
                }}>Gravar item</Button>

                <Button style={{ marginLeft: 8, marginRight: 8,  backgroundColor: "#240E92", color: "#FFF" }} onClick={() => {
                    finalizarItem();
                }}>Finalizar item</Button>
            </div>
        </div>
    );
}

export default AuditoriaExecutarItemPage;

